import { Card, CardContent } from "@/components/ui/card";

/**
 * Compact metric tile: an icon chip + a big number + a label.
 * `highlight` switches to the amber "needs attention" treatment used for
 * any non-zero action signal (matches the sponsor dashboard's "Expiring Soon").
 */
export function MetricCard({
  icon: Icon,
  label,
  value,
  highlight = false,
}: {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  value: number;
  highlight?: boolean;
}) {
  return (
    <Card>
      <CardContent className="flex items-center gap-4 p-4">
        <div className={`rounded-md p-2 ${highlight ? "bg-amber-500/10" : "bg-primary/10"}`}>
          <Icon className={`h-5 w-5 ${highlight ? "text-amber-500" : "text-primary"}`} />
        </div>
        <div>
          <p className="text-2xl font-bold">{value}</p>
          <p className="text-xs text-muted-foreground">{label}</p>
        </div>
      </CardContent>
    </Card>
  );
}
